import { UserId } from '@business/entities/account';
import { Endpoint } from '../endpoint';
import { PTOUserResponse, TimeoffID, TimeOffReportParams, TimeoffResponse, TimeoffUserHistoryResponse } from '@business/entities/pto';
import { CommonService } from '@business/services';
import { TimeOffFormData } from '@modules/timeoff/AddTimeOffModal/AddTimeOffModal';
import { TimeOffPageFormData } from '@modules/timeoff/TimeOffPage/TimeOffPage';
import { TimeoffReportFormData } from '@modules/timeoff/TimeOffReportExportModal/TimeOffReportExportModal';
import { JobId } from '@business/entities/job';

export function fetchUsers(params: TimeOffPageFormData) {
  return Endpoint.get<PTOUserResponse[]>(`@gc/timeoff/users`, { params });
}

export function saveTimeoff(data: TimeOffFormData) {
  return Endpoint.post<TimeoffResponse>(`@gc/timeoff`, { data });
}

export function updateTimeoff(id: TimeoffID, data: TimeOffFormData) {
  return Endpoint.patch<TimeoffResponse>(`@gc/timeoff/${id}`, { data });
}

export function fetchUserTimeoffs(id: UserId) {
  return Endpoint.get<TimeoffResponse[]>(`@gc/timeoff/user-timeoff/${id}`, {});
}

export function deleteTimeoff(id: TimeoffID) {
  return Endpoint.delete<void>(`@gc/timeoff/${id}`);
}

export function fetchAll(params: TimeOffReportParams) {
  return Endpoint.get<TimeoffResponse[]>(`@gc/timeoff/all`, { params });
}

export function exportReport(params: TimeoffReportFormData) {
  return Endpoint.get<void>(`@gc/timeoff/export`, { params });
}

export function downloadExport(jobId: JobId, filename: string) {
  return Endpoint.get<void>(`@gc/timeoff/download-export/${jobId}`, { isFile: true, filename });
}

export function fetchUserHistory(id: UserId) {
  return Endpoint.get<TimeoffUserHistoryResponse>(`@gc/timeoff/user-history/${id}`, {});
}
